export const surveyRequest = {
  id: 11684,
  approval_status: 2,
  requested_by: { full_name: "Damir Vujadinovic", id: 312 },
  created_at: "2026-05-12T13:41:44.000+00:00",
  updated_at: "2026-05-12T14:30:34.000+00:00",
  requested_for_formatted: {
    id: 184,
    name: "Precision Talent Solutions ",
    address_line_1: "123 Contract Blvd",
    address_line_2: "",
    city: "Atlanta",
    state_provence: "GA",
    zip: "30303",
    country: "USA",
    shortname: "ptscandidate",
    invite_url: null,
    password: null,
    hide_invites: false,
    fpf_very_low_limit: 29.5,
    fpf_low_limit: 44.5,
    fpf_moderate_limit: 64.5,
    fpf_high_limit: 79.5,
    cos_very_low_limit: 29.5,
    cos_low_limit: 44.5,
    cos_moderate_limit: 64.5,
    cos_high_limit: 79.5,
    cog_cutoff: 35.0,
    score_preference: 0,
    target_industry: 3,
    coach_report: true,
    select_report: true,
    medical_report: false,
    clinical_report: false,
    status: 0,
    cog_pref: 0,
    hol_company: false,
    comp_assess_company: false,
    manager_count: 37,
    employee_count: 3166,
    bullhorn_partner: true,
  },
  surveys_info: [
    {
      id: 19695,
      name: "CLEAR Screen",
      company_employee: {
        id: 22017,
        email: "pdmdirect@mail.com",
        first_name: "Paul ",
        last_name: "Maytham",
        full_name_search: "paul maytham",
        phone: null,
        in_queue: false,
        position: "Business Development Manager",
        division: "Trailer Bridge",
        hr_restricted: false,
        status: 1,
        note: null,
        test_url_emailed: false,
        test_url_emailed_at: null,
        secondary_email: null,
        third_party_identifier: null,
        salary_in_pennies: 0,
        hourly: false,
        hire_date: null,
        birth_date: null,
        gender: 0,
        ethnicity: 0,
        race: 0,
        created_at: "2026-05-12T13:41:35.000+00:00",
        updated_at: "2026-05-12T13:41:35.000+00:00",
        management: false,
        outside_associate: false,
        third_party_ident: null,
        company_id: 184,
        location_id: null,
        department_id: null,
        company_position_id: null,
      },
    },
  ],
  survey_container_id: 11763,
  is_360: false,
  closed: false,
  released: false,
};
